module.exports = __webpack_public_path__ + "img/jar.9180d10d.png";